import { formatTime } from '@utils/i18n';
import { SchedulerGridHeaderHourProps } from './types';
import { cn } from '@utils/cn';

export const SchedulerGridHeaderHour = ({ data, className }: SchedulerGridHeaderHourProps) => (
  <span className={cn(['py-1 text-xs font-bold text-neutral-500', className])}>
    {formatTime(data)}
  </span>
);
